<div class="flex-container">
	@for (contenuto of contenutiCorrelati; track $index) {
		<div class="flex-item">
			<div class="card-wrapper mx-auto h-100">
				<div class="card-with-image-default-item listing-item card-bg no-after card">
					<div class="img-responsive-wrapper">
						<div class="img-responsive">
							<figure class="img-wrapper">
								<img
									class="listing-image responsive"
									[src]="contenuto.imageUrl"
									[title]="'Cover contenuto correlato ' + contenuto.title"
									[attr.alt]="'Cover contenuto correlato ' + contenuto.title" />
							</figure>
						</div>
					</div>
					<div class="card-body">
						<h3 class="card-title h4">
							<a [href]="contenuto.address">
								{{ contenuto.title }}
							</a>
						</h3>
						<p class="card-text">
							{{ contenuto.body }}
						</p>
					</div>
				</div>
			</div>
		</div>
	}
</div>
